import { useFeatureGates } from '@office-start/feature-gates-service';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy, useMemo } from 'react';
import { withLazyErrorBoundary } from '../LazyFeature/withLazyErrorBoundary';
var LazyDebugInfoButton = lazy(function () {
    return import(
    /*webpackChunkName: "debug-info-component" */ '@office-start/debug-info-component');
});
export var DebugInfoButton = function () {
    var _a, _b;
    var featureGates = useFeatureGates().data;
    var DebugInfoButtonLazy = useMemo(function () {
        var _a, _b;
        return withLazyErrorBoundary(LazyDebugInfoButton, 'DebugInfoComponent', {
            disabled: !((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.debugInfoGates) === null || _b === void 0 ? void 0 : _b.debugInfoButtonEnabled),
            schedulePriority: IDLE_VERYLOW_PRIORITY,
        });
    }, [(_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.debugInfoGates) === null || _b === void 0 ? void 0 : _b.debugInfoButtonEnabled]);
    return React.createElement(DebugInfoButtonLazy, null);
};
//# sourceMappingURL=DebugInfoButton.js.map